module.exports = __webpack_public_path__ + "static/img/standard-1.504edd3c.png";